import { Middleware } from "@nuxt/types";
import { usePageStore } from "~/stores/page";
import { Logger } from "~/helpers/logger";
import { RoutableInterface } from "~/modules/GraphQL/types";
import skipPaths from "./skipPaths";

const urlResolverMiddleware: Middleware = async (context) => {
  const pageStore = usePageStore();
  const { path } = context.route;

  let clearUrl = path.replace(/[a-z]+\/[cp|]\//gi, "");
  const shouldSkip = skipPaths.includes(clearUrl);

  if (shouldSkip) {
    Logger.debug("middleware/url-resolver", `Skipping URL resolver for path: ${clearUrl}`);
    return;
  }

  const { data, errors } = await context.app.$vsf.$magento.api.route(clearUrl);

  Logger.debug("middleware/url-resolver/result", { data, errors });
  if (data && data.route) {
    if (data.route.redirect_code && data.route.redirect_code == 301 && data.route.relative_url) {
      return context.redirect(301, '/' + data.route.relative_url);
    }
  }

  const results: RoutableInterface | null = data?.route ?? null;
  if (!results || errors?.length) context.error({ statusCode: 404 });

  pageStore.$patch((state) => {
    state.routeData = results;
  });
};

export default urlResolverMiddleware;
